import { RefObject, useEffect } from "react"

type UsePreventDefaultProps = {
  ref: RefObject<Element | null>
  events: (keyof HTMLElementEventMap)[]
}

export const ScrollEvents: (keyof HTMLElementEventMap)[] = [
  'touchstart',
  'touchmove',
  'touchend',
  'wheel'
]
export const usePreventDefault = ({ ref, events }: UsePreventDefaultProps) => {
  useEffect(() => {
    const preventFn = (ev) => {
      ev.preventDefault()
    }

    events.forEach(e => ref.current?.addEventListener(e, preventFn, { passive: false }))

    return () => {
      events.forEach(e => ref.current?.removeEventListener(e, preventFn))
    }
  },)
}